import { useState } from "react";
import { Link } from "react-router-dom";
import ballerzLogo from "../../Assets/Images/ballerz-logo-white.png";
import wellPlayed from "../../Assets/Images/well-played.png";
import { useNavigate } from "react-router-dom";
import { BallerzUsers } from "../../Client/Ballerz";

export default function MobileFooter(props) {
  const [opened, setOpened] = useState(false);

  const navigate = useNavigate();

  const ballerzUsers = BallerzUsers();

  const handleLogout = () => {
    localStorage.setItem("ballerz-user", "");
    navigate("/login");
  };

  return (
    <>
      <div className="block sm:hidden bg-[#070d27] flex flex-col justify-center items-center mb-0 pb-0">
        <div className="mt-20 text-center px-6">
          <img src={wellPlayed} alt="Ballerz Logo" className="h-20 w-auto" />
        </div>

        {ballerzUsers.length > 1 && (
          <div className="w-full px-6 mt-10">
            <button
              onClick={() => navigate("/select-user")}
              className="block w-full border-[#4F55F6] border-2 text-white font-bold py-3 rounded-lg text-sm tracking-wide text-center px-6"
            >
              SWITCH USER
            </button>
          </div>
        )}

        <div className="w-full px-6 mt-10">
          <a
            href="https://ballerz.co.uk/book-now/"
            target="_blank"
            rel="noopener noreferrer"
            className="block w-full bg-red-600 text-white font-bold py-3 rounded-lg text-sm tracking-wide text-center"
          >
            RE-BOOK
          </a>
        </div>

        <div className="w-full px-6 mt-10">
          <button
            onClick={() => handleLogout()}
            className="block w-full bg-gray-600 text-white font-bold py-3 rounded-lg text-sm tracking-wide text-center px-6"
          >
            LOGOUT
          </button>
        </div>

        <div className="-mx-4 sm:-mx-6 w-screen bg-[#d92c4b] py-6 mt-10 flex justify-center items-center">
          <img src={ballerzLogo} alt="Ballerz Logo" className="h-6 w-auto" />
        </div>
      </div>
    </>
  );
}
